// ════════════════════════════════════════════════════════════════════════
//  Sterne einer Lektion aus dem gespeicherten Fortschritt ihrer Stufen.
//
//  Adapter, keine Regel: gerechnet wird mit `lessonStars` aus @otto/lehrgang,
//  damit Kind und Lehrkraft dieselbe Zahl sehen. Hier steht nur, wie der
//  Fortschritt der Lern-App in die Form kommt, die die Regel erwartet – die
//  Verwaltung hat ihren eigenen Adapter auf ihre Zeilenform.
//
//  Stufen ohne Eintrag fallen heraus, statt als 0 zu zählen: eine noch nicht
//  geübte Stufe darf die Sterne der Lektion nicht drücken.
// ════════════════════════════════════════════════════════════════════════

import { lessonStars, type Lesson, type StageResult } from "@otto/lehrgang";
import type { Progress } from "../../progress/lib/progress.js";

export function starsForLesson(
  lesson: Lesson,
  progress: Progress,
  thresholds: Parameters<typeof lessonStars>[1],
): 1 | 2 | 3 | null {
  const results: StageResult[] = [];
  for (const stage of lesson.stages) {
    const entry = progress[stage.key];
    if (entry) {
      results.push({
        stageKey: stage.key,
        accuracy: entry.accuracy,
        stars: entry.stars,
      });
    }
  }
  return lessonStars(results, thresholds);
}
